import { Modal } from 'antd';
import styled from 'styled-components';

import { createVar, sizeDown, sizeUp, vars } from '~/theme';

const _mainImgHeight = createVar('_alsoLikeModal-mainImgHeight');

export const Container = styled(Modal)(({ theme }) => ({
  ...vars({
    [_mainImgHeight]: sizeUp('300rem', ['md', '315rem']),
  }),

  width: 'auto !important',
  maxWidth: `${sizeUp('688rem', ['lg', '1168rem'])} !important`,
  height: '615rem',

  color: theme.palette.white,
  fontFamily: theme.typography.family.arial,

  '& .ant-modal-content': {
    backgroundColor: 'black',
    backgroundImage: `linear-gradient(180deg, ${theme.palette.graniteGray} 0%, ${theme.palette.black} 100%)`,
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'no-repeat',
    backgroundOrigin: 'padding-box',
    boxShadow: `15rem 30rem 15rem ${theme.palette.black}29`,
    borderRadius: '5rem',
    width: '100%',

    paddingInlineStart: sizeUp('40rem', ['lg', '72rem']),
    paddingInlineEnd: sizeUp('40rem', ['lg', '68rem']),
    paddingBlock: sizeUp('50rem', ['lg', '93rem']),
  },

  '& .ant-modal-footer': {
    marginTop: 0,
  },

  '& .ant-modal-close-icon': {
    color: theme.palette.white,
  },
}));

const closeBtnHeight = '38rem';

export const CloseBtn = styled.button(({ theme }) => ({
  backgroundColor: 'transparent',
  border: `solid 1px ${theme.palette.white}`,
  borderRadius: '19rem',
  paddingInline: '20rem',
  blockSize: closeBtnHeight,

  cursor: 'pointer',

  color: theme.palette.white,
  fontSize: theme.typography.size20,
}));

const alignFlexStart = 'flex-start';

export const Content = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: alignFlexStart,
  justifyContent: 'center',

  position: 'relative',

  [theme.breakpoint.media.min.md]: {
    flexDirection: 'row-reverse',
    gap: '50rem',
  },
}));

export const TrendingBadge = styled.span(({ theme }) => ({
  paddingInline: '5rem',
  paddingBlock: '4rem',
  borderRadius: '16rem',
  backgroundColor: theme.palette.orangeYellow,

  color: theme.palette.black,
  fontSize: theme.typography.size12,
  textTransform: 'uppercase',
}));

export const Details = styled.div(() => ({
  display: 'flex',
  alignItems: alignFlexStart,
  justifyContent: 'space-between',

  marginBlockStart: '8rem',
}));

export const Title = styled.div(({ theme }) => ({
  fontSize: theme.typography.size30,
  fontWeight: 'bold',
}));

export const Material = styled.div(({ theme }) => ({
  marginBlockStart: '10rem',

  fontSize: theme.typography.size20,
  fontWeight: 'normal',
}));

export const Pricing = styled.div(({ theme }) => ({
  textAlign: 'end',
  fontSize: theme.typography.size18,
}));

export const OriginalPrice = styled.span(() => ({
  textDecoration: 'line-through',
}));

export const DiscountPercentage = styled.span(({ theme }) => ({
  color: theme.palette.guppieGreen,
  textDecoration: 'none !important',
}));

export const Description = styled.div(({ theme }) => ({
  marginBlockStart: '25rem',

  fontSize: theme.typography.size16,
}));

export const Gallery = styled.div(() => ({
  maxInlineSize: sizeDown('100%', ['md', '544rem']),
}));

export const MainImage = styled.img(() => ({
  maxBlockSize: '100%',
  maxInlineSize: '100%',
  borderRadius: '5rem',
}));

export const MainImageContainer = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  blockSize: _mainImgHeight,
}));

export const Disclaimer = styled.div(({ theme }) => ({
  fontSize: theme.typography.size12,
}));

export const Carousel = styled.div(() => ({
  display: 'flex',
  gap: sizeUp('32.5rem', ['lg', '40rem']),

  marginBlockStart: sizeUp('20rem', ['lg', '27rem']),
  marginBlockEnd: sizeUp('20rem', ['lg', '56rem']),
}));

export const Thumbnail = styled.button(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  inlineSize: '75rem',
  blockSize: '75rem',
  borderRadius: '4rem',
  border: 'solid 3rem transparent',
  padding: 0,
  backgroundColor: 'transparent',

  cursor: 'pointer',
  overflow: 'hidden',

  '&[data-is-selected="true"]': {
    borderColor: theme.palette.blueJeans,
  },

  img: {
    maxHeight: '100%',

    objectFit: 'contain',
  },
}));

export const InfoArea = styled.div(() => ({
  position: 'relative',

  blockSize: `calc(${_mainImgHeight} + 45rem)`,
}));

const socialLinksHeight = '24rem';

export const SocialLinks = styled.ul(({ theme }) => ({
  listStyle: 'none',

  display: 'flex',
  gap: '25rem',

  height: socialLinksHeight,

  margin: 0,
  padding: 0,

  svg: {
    fontSize: socialLinksHeight,
    color: theme.palette.white,
  },

  [theme.breakpoint.media.min.lg]: {
    position: 'absolute',
    insetBlockEnd: `calc(((${socialLinksHeight} + ${closeBtnHeight})/2) * -1)`,
  },
}));

export const Features = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: alignFlexStart,
  justifyContent: 'center',
  gap: '50rem',

  marginBlock: '43rem',

  [theme.breakpoint.media.min.lg]: {
    position: 'absolute',
    insetInlineStart: 0,
    insetBlockEnd: 0,

    justifyContent: 'flex-start',

    marginBlock: 0,
  },

  span: {
    pointer: 'help',
  },

  svg: {
    inlineSize: '61rem',
    blockSize: '63rem',

    fill: theme.palette.white,
  },
}));
